'use client';

import Link from 'next/link';
import { useT } from '@/components/i18n-provider';
import { useEffect } from 'react';

export default function WorkspaceError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useT();
  useEffect(() => {
    console.error('Workspace error:', error);
  }, [error]);

  return (
    <div className="h-full w-full flex items-center justify-center p-6">
      <div className="glass-surface rounded-2xl px-6 py-5 max-w-md text-center">
        <div className="text-base font-semibold mb-1">{t('errors.workspaceUnavailable')}</div>
        <div className="text-sm text-muted-foreground mb-4">
          {error.message || 'Something went wrong loading this workspace.'}
        </div>
        <div className="flex items-center gap-2 justify-center">
          <button
            onClick={() => reset()}
            className="px-3 py-1.5 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90"
          >
            {t('errors.tryAgain')}
          </button>
          <Link
            href="/workspace"
            className="px-3 py-1.5 rounded-lg border border-border text-sm font-medium hover:bg-accent"
          >
            {t('errors.backToWorkspaces')}
          </Link>
        </div>
      </div>
    </div>
  );
}
